import { create } from "zustand";
import {
  devtools,
  persist,
  PersistOptions,
  subscribeWithSelector,
} from "zustand/middleware";

import { QUOTE_SESSION_NAME } from "@/consts";
import { isProductionOrStaging } from "@/utils/environment";

import { createAirportState } from "./airport/createAirportState";
import { createAppState } from "./app/createAppState";
import { createDateState } from "./arrival/createDateState";
import { createFlightTimesState } from "./flightTimes/createFlightTimesState";
import { sessionJSONStorage, WithDevtoolsPersist } from "./middleware";
import { createRoomsState } from "./rooms/createRoomsState";
import { createSharedState } from "./shared/createSharedState";
import type { QuotePersist, QuoteState } from "./types";

const createQuoteState: WithDevtoolsPersist<QuoteState, QuotePersist> = (
  ...args
) => ({
  ...createRoomsState(...args),
  ...createDateState(...args),
  ...createAirportState(...args),
  ...createFlightTimesState(...args),
  ...createAppState(...args),
  ...createSharedState(...args),
});

const devToolsOptions = {
  name: "Quote Store",
  enabled: !isProductionOrStaging(),
};

export const persistOptions: PersistOptions<QuoteState, QuotePersist> = {
  name: QUOTE_SESSION_NAME,
  partialize: ({
    roundAllocation,
    productCode,
    tta,
    rooms,
    quoteRef,
  }: QuoteState): QuotePersist => ({
    roundAllocation,
    productCode,
    tta,
    totalGolfers: rooms.reduce((acc, room) => acc + room.pax, 0),
    quoteRef,
  }),
  storage: sessionJSONStorage,
};

export const useQuoteStore = create<QuoteState>()(
  subscribeWithSelector(
    devtools(persist(createQuoteState, persistOptions), devToolsOptions),
  ),
);
